<template>
  <ThreeColumn :breadcrumbPaths="paths">
    <template v-slot:title>
      <h1 class="text-h1 mb-0">{{$t('btntxt.ft_legal')}}</h1>
    </template>

    <template v-slot:leftPanel>
      <TocWidget :toc="contentswdgt"></TocWidget>
    </template>

    <template v-slot:mainPanel>
      <v-divider></v-divider>
      <v-row id="disclaimer" class="pt-3 pb-12" no-gutters>
         <v-col>
          <h2 class="text-h2 liiblack--text mb-4">{{$t('legal.disclaimer')}}</h2>
          <i18n path="legal.dis[0]" tag="p">
            <router-link to="/">{{$t('home.fullname')}}</router-link>
            <a href="http://www.lawtech.hk/" target="_blank">{{$t('about.law_and_tech')}}</a>
            <a href="http://www.cs.hku.hk/" target="_blank">{{$t('about.cs_dept')}}</a>
            <a href="http://www.hku.hk/law/" target="_blank">{{$t('about.law_fac')}}</a>
            <a href="http://www.austlii.edu.au/" target="_blank">{{$t('legal.austlii')}}</a>
            <a href="http://www.unsw.edu.au/" target="_blank">{{$t('legal.unsw')}}</a>
            <a href="http://www.uts.edu.au" target="_blank">{{$t('legal.uts')}}</a>
          </i18n>
          <p>{{$t('legal.dis[1]')}}</p>
          <p>{{$t('legal.dis[2]')}}</p>
          <p>{{$t('legal.dis[3]')}}</p>
          <p>{{$t('legal.dis[4]')}}</p>
          <p>{{$t('legal.dis[5]')}}</p>
         </v-col>
      </v-row>
      
      <v-divider></v-divider>
      <v-row id="privacy" class="pt-3 pb-12" no-gutters>
        <v-col>
          <h2 class="text-h2 liiblack--text mb-4">{{$t('legal.privacy')}}</h2>
          <p>{{$t('legal.pp[0]')}}</p>

          <h3 class="text-h3 navlink--text">{{$t('legal.pp_a')}}</h3>
          <p class="bulletp"><b>A1. </b>{{$t('legal.pp[1]')}}</p>
          <p class="bulletp"><b>A2. </b>{{$t('legal.pp[2]')}}</p>
          <p class="bulletp"><b>A3. </b>{{$t('legal.pp[3]')}}</p>
          <br>
          <h3 class="text-h3 navlink--text">{{$t('legal.pp_b')}}</h3>
          <p class="bulletp"><b>B1. </b>{{$t('legal.pp[4]')}}</p>
          <p class="bulletp"><b>B2. </b>{{$t('legal.pp[5]')}}</p>

          <p>{{$t('legal.pp[6]')}}</p>
          <p>{{$t('legal.pp[7]')}}</p>
          <i18n path="legal.pp[8]" tag="p">
            <router-link to="/feedback">{{$t('legal.pp_feedback')}}</router-link>
          </i18n>
        </v-col>
      </v-row>

      <v-divider></v-divider>
      <v-row id="usage" class="pt-3 pb-12" no-gutters>
        <v-col>
          <h2 class="text-h2 liiblack--text mb-4">{{$t('legal.up_title')}}</h2>
          <h3 class="text-h3 navlink--text">{{$t('legal.up_1')}}</h3>
            <p class="bulletps"><b>(a)</b> {{$t('legal.up[0]')}}</p>
            <p class="bulletps"><b>(b)</b> {{$t('legal.up[1]')}}</p>
            <p class="bulletps"><b>(c)</b> {{$t('legal.up[2]')}}</p>
            <p class="bulletps"><b>(d)</b> {{$t('legal.up[3]')}}</p>
            <p class="bulletps"><b>(e)</b> {{$t('legal.up[4]')}}</p>
            <ol type="i">
              <li v-for="(item,idx) in $t('legal.up_1e')" :key="idx">{{item}}</li>
            </ol>
            <br>
          <h3 class="text-h3 navlink--text">{{$t('legal.up_2')}}</h3>
            <p class="bulletps"><b>(a)</b> {{$t('legal.up[5]')}}</p>
            <p class="bulletps"><b>(b)</b> {{$t('legal.up[6]')}}</p>
            <br>
          <h3 class="text-h3 navlink--text">{{$t('legal.up_3')}}</h3>
            <p class="bulletps"><b>(a)</b> {{$t('legal.up[7]')}}</p>
            <p class="bulletps"><b>(b)</b> {{$t('legal.up[8]')}}</p>
            <br>
          <h3 class="text-h3 navlink--text">{{$t('legal.up_4')}}</h3>
            <p class="bulletps"><b>(a)</b> {{$t('legal.up[9]')}}</p>
            <p class="bulletps"><b>(b)</b> {{$t('legal.up[10]')}}</p>
            <br>
          <h3 class="text-h3 navlink--text">{{$t('legal.up_5')}}</h3>
            <p class="bulletps"><b>(a)</b> {{$t('legal.up[11]')}}</p>
            <p class="bulletps"><b>(b)</b> {{$t('legal.up[12]')}}</p>
            <p class="bulletps"><b>(c)</b> {{$t('legal.up[13]')}}</p>
            <p class="bulletps"><b>(d)</b> {{$t('legal.up[14]')}}</p>
            <br>
            <p>{{$t('legal.up[15]')}}</p>
            <br>
            <p class="pt-3 font-weight-bold darkgrey--text">
              HKLII<br>
              {{$t('about.uni')}}<br>
              {{$t('legal.date')}}
            </p>
        </v-col>
      </v-row>

    </template>
  </ThreeColumn>
</template>

<script>
  import ThreeColumn from '@/components/applayout/ThreeColumn'
  import TocWidget from '../components/TocWidget'
  export default {
    name: 'Legal',
    components:{
      ThreeColumn,
      TocWidget
    },
    /*watch: {
      '$i18n.locale': function(){
        window.document.title = `${this.$i18n.t('btntxt.ft_legal')} | HKLII`
      }
    },*/
    computed:{
      contentswdgt(){
        return [
          {'title':this.$i18n.t('legal.disclaimer'), id:'disclaimer'},
          {'title':this.$i18n.t('legal.privacy'), id:'privacy'},
          {'title':this.$i18n.t('legal.usage'), id:'usage'},
        ]
      },
      paths(){
        return [
          {text: 'HKLII', disabled: false, href: {name: 'home'}},
          {text: this.$i18n.t('btntxt.ft_legal'), disabled: true}
        ]
      }
    },
    /*mounted(){
      window.document.title = `${this.$i18n.t('btntxt.ft_legal')} | HKLII`
    },*/
    metaInfo(){
      return{
        title: this.$i18n.t('btntxt.ft_legal'),
      }
    },
  }
</script>
<style scoped lang="scss">
 @import '@/sass/_typography.scss';

  td {
    padding-right: 10px;
    padding-bottom: 10px;
  }

  ol {
    padding-left: 3em;
  }

  li {
    padding-left: 1em;
  }

  #maincon a {
    @include link-no-underline;
  }

  .bulletp { /* for longer A1. items */
    text-indent: -2em;
    padding-left: 2em;
  }

  .bulletps { /* for shorter (a) items */
    text-indent: -1.5em;
    padding-left: 1.5em;
  }

</style>